module.exports = __webpack_public_path__ + "static/img/icon-right.28dee8f.png";